import { EnvironmentProviders, ErrorHandler, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import * as Sentry from "@sentry/angular";
import {SentryService} from './sentry.service';
import {Config} from "../config/config.service";
import {Router} from "@angular/router";

import {CB_CORE_ENV, CbCoreEnvironment} from '../../environment/cb-core-env.token';

export function provideSentry(): EnvironmentProviders {
  return makeEnvironmentProviders([
    SentryService,
    {
      provide: ErrorHandler,
      useFactory: (env: CbCoreEnvironment) => Sentry.createErrorHandler({ showDialog: env.sentryShowDialog ?? false }),
      deps: [CB_CORE_ENV]
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const env = inject(CB_CORE_ENV);
      const sentryService = inject(SentryService);
      const config = inject(Config);
      if (config.CONFIG.isMobile && !env.sentryUrl && !env.production) return;
      sentryService.init();
    })
  ]);
}
